import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fuse} from '@api'
import {ContentTitleBarItemField, SearchPopover, useVipLocalStore, VipLocalStore, ChangeLogFilterFieldConfig} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './ChangeLogWorkspaceItems.css'

/// region Store

export class ChangeLogWorkspaceItemsStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @computed get availableWorkspaces() {
    const {workspaces: {availableWorkspaces, wrapperById}} = this
    return availableWorkspaces?.filter(ws => wrapperById[ws._id].visible && ws.catalog?.index)
  }

  @observable fuse = new Fuse(this.availableWorkspaces, {keys: ['title']})

  @computed get sortedWorkspace() {
    const {fuse, availableWorkspaces, searchText} = this

    return searchText ? fuse.search(searchText).map(f => f.item) : availableWorkspaces
  }

  @observable searchText: string = ''

  @action onSearch = (event) => {
    this.searchText = event.target.value
  }

  @computed get field() {
    return this.props.field
  }

  get selected() {
    return this.props.selected
  }

  @computed get label() {
    const {field} = this
    return field.label
  }

  @computed get text() {
    const {label, selected} = this
    return (selected ?? []).length ? `(${selected.length}) Selected` : `Select ${label}`
  }

}

export const ChangeLogWorkspaceItemsStoreContext = React.createContext<ChangeLogWorkspaceItemsStore>(null)
export const useChangeLogWorkspaceItemsStore = () => React.useContext(ChangeLogWorkspaceItemsStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  field: ChangeLogFilterFieldConfig
  selected?: any
  onChange?: Function
}

export const ChangeLogWorkspaceItems = observer<MyProps>(function ChangeLogWorkspaceItems({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ChangeLogWorkspaceItemsStore(stores, obsProps)),
    {field, sortedWorkspace, selected, onSearch, searchText, props: {onChange}, text, strings} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <ChangeLogWorkspaceItemsStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <SearchPopover onSearch={onSearch} searchText={searchText} text={text} selectedEl={(selected ?? []).length > 0 && selected.map(ws => {
          return <ContentTitleBarItemField key={ws.title}
                                           field={{type: 'workspace', label: ws.title, index: ws.catalog?.index} as ChangeLogFilterFieldConfig}
                                           onSelectMenuItem={() => onChange(selected.filter(s => s.title !== ws.title))}
                                           renderTo={'applied'}
                                           isSelected
                                           searchText={searchText}/>
        })}>
          {sortedWorkspace.map(ws => {
            const isSelected = (selected ?? []).some(s => s.title === ws.title)
            return <ContentTitleBarItemField key={ws.title}
                                             field={{type: 'workspace', label: ws.title, index: ws.catalog?.index} as ChangeLogFilterFieldConfig}
                                             onSelectMenuItem={() => onChange(isSelected ? selected.filter(s => s.title !== ws.title) : [...(selected ?? []), ws])}
                                             isSelected={isSelected}
                                             renderTo={'all'}
                                             searchText={searchText}/>
          })}
        </SearchPopover>
      </div>
    </ChangeLogWorkspaceItemsStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogWorkspaceItems.tsx